import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes = () => {
    const token = window.localStorage.getItem("arab_user_token");

    return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoutes;
